import axios from "axios";
import { api } from "~/router/apiConfig";
import { BALANCE_PERIOD_ALL } from "~/constants/contract/balance/period";

export function index(contractId, periodId = BALANCE_PERIOD_ALL) {
  return axios.get(
    api.path("contractEntitySpend.index", {
      contractId,
      periodId
    })
  );
}
